// extracted by mini-css-extract-plugin
module.exports = {"fields":"IncidentBase_fields__rOhna","root":"IncidentBase_root__hM1Cx","section":"IncidentBase_section__2BNVN","chip":"IncidentBase_chip__2O3Uh"};